// @flow

import React, { PureComponent } from 'react'
import SlickSlider from 'react-slick'
import ItemWrapper from './ItemWrapper'
import { PrevArrow, NextArrow } from './Arrows'
import * as Styled from './styled'
import '../Swipe/swipe-slider-styles.css'
import {
  getSliderProps,
  getLeftOffsetFromActive,
  getRightOffsetFromActive
} from './utils'

const ADDITIONAL_PADDING = 150

class Slider extends PureComponent<*, *> {
  constructor(props) {
    super(props)

    const slidesLength = React.Children.count(props.children)
    this.initialSlide = parseInt(slidesLength / 2)

    this.state = {
      activeIndex: this.initialSlide
    }
  }

  getOffsetFromCenter = (idx: number) => {
    const slidesLength = React.Children.count(this.props.children)
    const { activeIndex } = this.state

    const rightOffset = getRightOffsetFromActive(idx, activeIndex, slidesLength)
    const leftOffset = getLeftOffsetFromActive(idx, activeIndex, slidesLength)

    if (rightOffset > leftOffset) {
      return -leftOffset
    } else if (rightOffset === leftOffset && rightOffset === 1) {
      return NaN
    }
    return rightOffset
  }

  onBeforeChange = (_, newIdx: number) => {
    this.setState({
      activeIndex: newIdx
    })
    this.props.onBeforeChange && this.props.onBeforeChange(newIdx)
  }

  render() {
    const { slickProps = {}, breakPoints, itemProps } = this.props
    const slidesLength = React.Children.count(this.props.children)
    const sliderProps = {
      ...getSliderProps(slidesLength, breakPoints),
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />
    }

    return (
      <div
        style={{
          maxWidth:
            sliderProps.slidesToShow * itemProps.width + ADDITIONAL_PADDING,
          margin: '0 auto'
        }}
      >
        <Styled.GlobalStyles />
        <SlickSlider
          {...sliderProps}
          {...slickProps}
          initialSlide={this.initialSlide}
          beforeChange={this.onBeforeChange}
        >
          {React.Children.map(this.props.children, (child, idx) => {
            const offsetFromCenter = this.getOffsetFromCenter(idx)
            return (
              <ItemWrapper
                {...itemProps}
                animationDuration={sliderProps.speed}
                offsetFromCenter={offsetFromCenter}
                key={idx}
              >
                {child}
              </ItemWrapper>
            )
          })}
        </SlickSlider>
      </div>
    )
  }
}

Slider.defaultProps = {
  itemProps: {
    width: 170,
    height: 170,
    sizes: {
      large: 170,
      medium: 120,
      small: 60
    },
    additionalOffset: 30
  }
}

export default Slider
